import { render, staticRenderFns } from "./EventsList.vue?vue&type=template&id=d0ef1676&scoped=true"
import script from "./EventsList.vue?vue&type=script&lang=js"
export * from "./EventsList.vue?vue&type=script&lang=js"
import style0 from "./EventsList.vue?vue&type=style&index=0&id=d0ef1676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ef1676",
  null
  
)

export default component.exports